var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-config"},[(this.data && Object.keys(this.data).length > 0)?_c('el-form',{attrs:{"label-suffix":"：","labelPosition":"left","labelWidth":"120px","size":"small"}},[_c(`config-${_vm.data.type}`,{tag:"component",attrs:{"data":_vm.data,"collapse":_vm.collapse}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }